
import { defineComponent, reactive } from "vue";
import { useRouter } from "vue-router";
import runEvn from "@/modular/runEvn/RunEvn";
import {
  getCartList,
  deleteCart,
  confirmNewProduct,
  editCart,
} from "@/api/shopApi";

const fileBaseUrl = runEvn().fileBaseUrl;

export default defineComponent({
  name: "Home",
  setup() {
    const router = useRouter();
    const state = reactive({});
    return {
      router, //一定要要放在return里才能在模板上面使用
      state,
    };
  },
  data() {
    return {
      cartList: [],
      selAll: false,
      selGoods: [],
      // 总价
      totalPrice: 0,
    };
  },
  components: {},
  watch: {},
  created: async function () {
    // this.getCartList();
    if (this.$refs.appList) {
      this.$refs.appList.refresh();
    }
  },
  computed: {},
  methods: {
    //购物车列表
    async getCartList({ setData }) {
      const res = await getCartList();
      this.cartList = res.products;
      setData(res.products, res.totalNum);
      this.totalPrice = 0;
      this.selGoods = [];
      this.selAll = false;
    },
    splitImg(key: string) {
      const arr = key.split(",") || [""];
      return this.img(arr[0]);
    },
    img(key: string) {
      return fileBaseUrl + key;
    },
    // 单选的change事件
    chooseChange(i, item) {
      const arr = this.selGoods.filter((it) => {
        if (it.id == i) {
          return true;
        } else {
          return false;
        }
      });
      if (arr.length > 0) {
        var arrs = this.selGoods.filter(function (item) {
          return item.id != i;
        });
        this.selGoods = arrs;
        item.isChecked = false;
        this.count();
      } else {
        this.selGoods.push(item);
        item.isChecked = true;
      }
      if (this.selGoods.length < this.cartList.length) {
        this.selAll = false;
      } else {
        this.selAll = true;
      }
      this.count();
    },
    // 商品数量
    async updateNum(item) {
      if (!item.num) {
        item.num = 1;
        return;
      }

      const toastObj = this.$toast.loading({
        overlay: true,
        forbidClick: true,
      });
      let obj = {
        id: item.id,
        num: item.num,
      };
      //   debugger
      let isOk = await editCart(obj);

      if (isOk) {
        const res = this.selGoods.find((c) => c.id == item.id);
        //更新选中的item的总价格
        if (res) {
          let buyItems = [];
          this.selGoods.forEach((item) => {
            let obj = {
              id: item.id,
            };
            buyItems.push(obj);
          });
          let data = {
            buyItems: buyItems,
            type: 1,
          };
          let list = (await confirmNewProduct(data)) as any;
          this.totalPrice = list.disregardFreightTotalPrice;
        }
      }

      toastObj.close();
    },
    // 计算价格
    count: function () {
      let totalPrice = 0; //临时总价
      this.cartList.forEach(function (val) {
        if (val.isChecked) {
          totalPrice += val.num * val.presentPrice; //累计总价
        }
      });
      this.totalPrice = parseFloat(totalPrice.toFixed(2));
    },
    //删除
    delcard(item, index) {
      this.$dialog
        .confirm({
          message: `您确定要删除${item.name}吗?`,
        })
        .then(() => {
          let isOk = deleteCart(item.id);
          if (isOk) {
            this.cartList.splice(index, 1);
            let i = this.selGoods.indexOf(item);
            if (i != -1) {
              this.selGoods.splice(i, 1);
            }
            this.$refs.appList.spliceData(index);
            this.$toast.success("删除成功");
            if (this.selGoods.length <= this.cartList.length) {
              this.selAll = false;
            } else {
              this.selAll = true;
            }
            this.count();
          }
        })
        .catch(() => {
          // on cancel
        });
    },
    // 全选
    checkAll() {
      let list = this.cartList;
      if (this.selAll === false) {
        list.forEach((element) => {
          element.isChecked = false;
        });
        this.selGoods = [];
        this.count();
      } else {
        list.forEach((element) => {
          element.isChecked = true;
          if (this.selGoods.indexOf(element.id) < 0) {
            this.selGoods.push(element);
          }
        });
        this.count();
      }
    },
    // 去结算
    onSubmit() {
      // 选择购买的商品
      let cartgoods = [];
      let idArr = [];

      this.cartList.forEach(function (item) {
        if (item.isChecked) {
          cartgoods.push(item);
        }
      });

      if (cartgoods.length === 0) {
        this.$toast("请选择商品购买");
      } else {
        let buyItemsArr = [];
        let id = "";
        for (let index = 0; index < cartgoods.length; index++) {
          const element = cartgoods[index];
          idArr.push(element.id);
          if (element.standardInfo.length == 0) {
            let obj = {
              id: element.id,
              num: element.num,
              productStandard: null,
            };
            buyItemsArr.push(obj);
          } else {
            // let item = {
            //   productStandardId: element.productStandardId,
            //   productId: element.productId,
            //   productSpecs: element.productSpecs,
            //   productStock: element.productStock,
            //   productPrice: element.productPrice,
            //   sortBy: element.sortBy,
            //   isCheck: element.isCheck,
            //   costPrice: element.costPrice,
            // };
            let obj = {
              id: element.id,
              num: element.num,
              // productStandard: item,
            };
            buyItemsArr.push(obj);
          }
        }
        
        sessionStorage.setItem("buyItems", JSON.stringify(buyItemsArr));

        this.router.push({
          path: `/shop/goods/order`,
          query: {
            id: idArr.join(","),
            typeOrder: 1,
          },
        });
      }
    },
    // 处理html的text
    headerHtml(htmlText) {
      if (htmlText) {
        let str = htmlText;
        str = str.replace(/(\n)/g, "");
        str = str.replace(/(\t)/g, "");
        str = str.replace(/(\r)/g, "");
        str = str.replace(/<\/?[^>]*>/g, "");
        str = str.replace(/\s*/g, "");
        str = str.replace(/<[^>]*>/g, "");
        return str;
      }
      return "";
    },
    // 处理html的text
    standardHtml(htmlText) {
      if (htmlText) {
        let obj = JSON.parse(htmlText);
        let str = "";
        for (var key in obj) {
          str = str + obj[key] + "  ";
        }
        return str;
      }
      return "";
    },
  },
});
